module.exports = __webpack_public_path__ + "static/media/whoneedsprint2Web.a1d95d97.jpg";